import toast from "react-hot-toast";
import Axios from "../../services/axios";

export const getAPI = (url) => {
  return Axios.get(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response) {
        toast.error(
          err?.response?.data?.errors?.length &&
            err?.response?.data?.errors[0]?.message
        );
        // return err?.response?.data?.errors[0]?.message
      } else {
        toast.error(err.message);
      }
    });
};

export const postAPI = (url, body) => {
  return Axios.post(url, body)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err
  //     if (err.response) {
  //       toast.error(
  //         err?.response?.data?.errors?.length &&
  //           err?.response?.data?.errors[0]?.message
  //       );
  //       // return err?.response?.data?.errors[0]?.message
  //     } else {
  //       toast.error(err.message);
  //     }

    });
};
